<template>
  <div class="ent-and-exit-manage">
    <breadcrumb :breadcrumb="breadcrumb" />

    <div class="ent-and-exit-manage-main">
      <div class="ent-and-exit-manage-main-item" v-for="(location, locationIndex) in pageDeviceList">
        <div class="ent-and-exit-manage-main-item-title">{{pageDeviceNameList[locationIndex]}}</div>
        <div class="ent-and-exit-manage-main-item-device-box">
          <div class="ent-and-exit-manage-main-item-device-line" v-for="device in location">
            <div class="ent-and-exit-manage-main-item-device-line-top">
              <div style="background-color: #F56C6C;width: 18px;height: 18px;border-radius: 50%;" v-if="device.deviceStatus === '0'"></div>
              <div style="background-color: #67C23A;width: 18px;height: 18px;border-radius: 50%;" v-else-if="device.deviceStatus === '1'"></div>
              <div class="ent-and-exit-manage-main-item-device-line-top-name">{{device.name}}</div>
            </div>
            <div class="ent-and-exit-manage-main-item-device-line-bottom">
              <div class="ent-and-exit-manage-main-item-device-line-bill" v-if="device.passType !== '1'" @click="dialogVisible = true">查看账单</div>
              <div class="ent-and-exit-manage-main-item-device-line-bottom-btn" @click="parkingAccessManageOpenGate(device)">开闸</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="账单查询" :visible.sync="dialogVisible" width="50%">
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">车牌号：</span>
        </div>
        <el-select v-model="searchKey" filterable remote reserve-keyword placeholder="请输入关键词" :loading="billLoading" size="mini" style="width: 280px" :remote-method="searchKeyRemoteMethod">
          <el-option v-for="item in billList" :key="item.code" :label="item.carNumber" :value="item.code"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">进场时间：</span>
        </div>
        <el-input v-model="billInfo.carInTime" size="small" style="width: 280px" disabled />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">出场时间：</span>
        </div>
        <el-input v-model="billInfo.carOutTime" size="small" style="width: 280px" disabled />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">停车时长：</span>
        </div>
        <el-input v-model="billInfo.parkingDuration" size="small" style="width: 280px" disabled />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">应收金额：</span>
        </div>
        <el-input v-model="billInfo.money" size="small" style="width: 280px" disabled>
          <template slot="append">元</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">实收金额：</span>
        </div>
        <el-input v-model="billInfo.payMoney" size="small" style="width: 280px" disabled >
          <template slot="append">元</template>
        </el-input>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/ParkingService'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'ent-and-exit-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧停车',
          name: 'parking-device-management'
        }, {
          value: '出入口管理'
        }],
        exportUrl: '',

        pageDeviceList: [],
        pageDeviceNameList: [],
        dialogVisible: false,

        searchKey: '',
        billLoading: false,
        billList: [],
        billInfo: {}
      }
    },
    created () {
      this.getParkingAccessManageList()
    },
    methods: {
      // 获取列表
      getParkingAccessManageList () {
        this.$axios.post(api.getParkingAccessManageList, {})
          .then(res => {
            let data = res.data.data
            let pageDeviceList = [], pageDeviceNameList = []
            data.map(v => {
              if (pageDeviceNameList.indexOf(v.location) === -1) {
                pageDeviceNameList.push(v.location)
              }
            })
            pageDeviceNameList.map((v, i) => {
              data.map(device => {
                if (device.location === v) {
                  if (!pageDeviceList[i]) {
                    pageDeviceList[i] = []
                  }
                  pageDeviceList[i].push(device)
                }
              })
            })
            this.pageDeviceList = pageDeviceList
            this.pageDeviceNameList = pageDeviceNameList
          })
          .catch(errorHandler('获取列表失败'))
      },

      parkingAccessManageOpenGate (device) {
        if (device.deviceStatus === '0') {
          nError('设备离线，无法开闸')
          return
        }
        this.$axios.post(api.parkingAccessManageOpenGate, {
          dhHandle: device.dhHandle
        })
          .then(res => {
            nSuccess('开闸成功')
          })
          .catch(errorHandler('开闸失败'))
      },

      // 账单搜索
      searchKeyRemoteMethod (query) {
        this.billLoading = true;
        this.$axios.post(api.getParkingBillList, {
          searchKey: query
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.billLoading = false;
              let data = res.data.data
              this.billList = data
            }
          })
          .catch(errorHandler('获取账单失败'))
      }
    },
    watch: {
      searchKey (val) {
        this.billList.map(v => {
          if (v.code === this.searchKey) {
            this.billInfo = v
          }
        })
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
  .form-line {
    width: 420px;
    margin: 20px auto;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
  .ent-and-exit-manage {
    width: 100%;
    .ent-and-exit-manage-main {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      padding: 40px 5%;
      .ent-and-exit-manage-main-item {
        width: 40%;
        height: 242px;
        border: 1px solid #cccccc;
        margin-bottom: 40px;
        .ent-and-exit-manage-main-item-title {
          height: 40px;
          line-height: 40px;
          font-size: 20px;
          color: #ffffff;
          background-color: #67C23A;
          text-align: left;
          padding: 0 20px;
        }
        .ent-and-exit-manage-main-item-device-box {
          height: 200px;
          overflow-y: auto;
          .ent-and-exit-manage-main-item-device-line {
            height: 100px;
            padding: 20px 10px 10px;
            border-bottom: 1px solid #cccccc;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            .ent-and-exit-manage-main-item-device-line-top {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              .ent-and-exit-manage-main-item-device-line-top-name {
                font-size: 16px;
                margin-left: 10px;
              }
            }
            .ent-and-exit-manage-main-item-device-line-bottom {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              .ent-and-exit-manage-main-item-device-line-bill {
                color: #58B6E5;
                cursor: pointer;
                margin-right: 40px;
              }
              .ent-and-exit-manage-main-item-device-line-bottom-btn {
                width: 80px;
                height: 36px;
                line-height: 34px;
                color: #FFFFFF;
                background-color: #58B6E5;
                border-radius: 5px;
                cursor: pointer;
              }
            }
          }
          .ent-and-exit-manage-main-item-device-line:last-child {
            border: 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/EntAndExitManage/EntAndExitManage.vue